import React from 'react';
import PropTypes from 'prop-types';
import { connect } from 'react-redux';

import Helper from '@app/helper';

import Browser from '@wetransfer/concorde-browser';

import I18n from '@module/i18n';

import Config from '@app/config';

export const shouldTriggerAppNotification = (transfer = {}) => {
  return (
    (Browser.isIphone || Browser.isAndroid) &&
    Config.mobileAppBanner.active === true &&
    transfer &&
    (transfer.state === 'downloadable' ||
      transfer.state === 'password_protected')
  );
};

const AppBarHOC = (WrappedComponent) => {
  const HOCComponent = ({ transfer, route }) => {
    if (!shouldTriggerAppNotification(transfer)) {
      return null;
    }

    const title = I18n.t('notification.mobile_app_banner_title');
    const description = I18n.t('notification.collect_app_banner_desc');
    const openAppTitle = I18n.t('notification.mobile_app_banner_open');
    const downloadAppTitle = I18n.t('notification.mobile_app_banner_download');

    return (
      <WrappedComponent
        downloadUri={Helper.downloadAppUri()}
        appUri={Helper.openInAppUri(transfer, route).href}
        title={title}
        description={description}
        openAppTitle={openAppTitle}
        downloadAppTitle={downloadAppTitle}
      />
    );
  };

  HOCComponent.displayName = `AppBarHOC(${WrappedComponent.displayName ||
    WrappedComponent.name})`;

  HOCComponent.propTypes = {
    transfer: PropTypes.object.isRequired,
    route: PropTypes.object.isRequired,
  };

  const mapStateToProps = ({ transfer, route, session }) => ({
    transfer,
    route,
    session,
  });

  return connect(mapStateToProps)(HOCComponent);
};

export default AppBarHOC;
